import i18nFactory from '@yandex-int/i18n';

import { ChatListEditorData, ChatListItem } from '../../typings/chatList';
import { createErrorsMapper } from '../ErrorsMapper/ErrorsMapper';

import * as keyset from './ChatListEditor.i18n';

const i18n = i18nFactory(keyset);

export const chatListInitialData: ChatListEditorData = {
    isOpen: false,
    searchInputText: '',
    filteredChats: undefined
};

export const chatListErrorsMapper = createErrorsMapper<{}>(
    ({ idx }) => [
        {
            path: [],
            codes: [
                {
                    code: 'DefectIds.OBJECT_NOT_FOUND',
                    message: (): string => i18n('chat-not-found')
                }
            ]
        }
    ],
    () => i18n('text-error')
);

export const findChatOperatorById = (
    chats?: ChatListItem[],
    chatId?: string
): ChatListItem | undefined => {
    if (chats === undefined || chatId === undefined) {
        return undefined;
    }

    return chats.find(chat => chat.id === chatId);
};
